module.exports = __webpack_public_path__ + "img/twofactorauth.e73f7364.svg";